import React,{ useEffect, useState } from 'react';
import './ProfessionalSkills.scss';

import Button from "../../../../components/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import { useUpdatePartnerSkills } from "../../../../hooks/partnerHook/useSkills";
import IntroPage from '../../DashboardPages/IntroPage/IntroPage';

function ProfessionalSkills() {
     const [isSubmitClicked,setIsSubmitClicked]=useState(false);
     const [groupedSkills, setGroupedSkills] = useState({});
        const [userSkills, setUserSkills] = useState([]);
        const allSkills = useSelector((state) => state.siteData.partnerSkills);
        const dispatch = useDispatch();
        
    
        useEffect(() => {
            const grouped = groupSkillsByCategory(allSkills);
            setGroupedSkills(grouped);
        }, [allSkills]);
    
        const groupSkillsByCategory = (skills) => {
            const grouped = {};
            skills.forEach((skill) => {
                if (!grouped[skill.skill_category]) {
                    grouped[skill.skill_category] = [];
                }
                grouped[skill.skill_category].push(skill);
            });
            return grouped;
        };
    
        const handleSkillClick = (skill) => {
            setUserSkills((prevSkills) => {
                const isSelected = prevSkills.some((s) => s.skill_id === skill.skill_id);
                if (isSelected) {
                    return prevSkills.filter((s) => s.skill_id !== skill.skill_id);
                } else {
                    return [...prevSkills, skill];
                }
            });
        };
        const { mutate, isSuccess, isError, isPending } = useUpdatePartnerSkills()
        const handleSkillSubmission = async () => {
            try {
                console.log("Selected Skills:", userSkills);
                mutate(userSkills);
                setIsSubmitClicked(true);
            } catch (error) {
                console.error("Error submitting skills:", error);
            }
        };
        
     
    
  return (
    // <div className="container-background content-center">
    
  <>
    {isSubmitClicked?<IntroPage/>:
        <div >
      <div className="progress">
      <span>Step 3 of 3</span>
      {/* <span className="info">*Mandatory field</span> */}
    </div>
     <div className="skills-container">
       
     <div className="page-header">
         <h2 className="page-heading">Choose Your Skills</h2>
         <p className="page-sub-heading">Choose up to 3 skills to help clients find your services.</p>
     </div>
     <div className="skills-list">
         <div className="skills">
             {Object.keys(groupedSkills).map((category, index) => (
                 <div key={index}>
                     <div className="skills-category-header">
                         <h3>{category}</h3>
                     </div>
                     <div className="sub-skills-container">
                         {groupedSkills[category].map((skill) => (
                             <p
                                 key={skill.skill_id} 
                                 className={userSkills.some((s) => s.skill_id === skill.skill_id) ? 'selected-role' : ""}
                                 data-id={skill.skill_id}
                                 onClick={() => handleSkillClick(skill)}
                             >
                                 {skill.skill_name}
                             </p>
                         ))}
                     </div>
                 </div>
             ))}
         </div>
         <div className="skills-btn-container">
             <Button
                 className={userSkills.length > 0 ? 'save-skills-btn' : 'disabled-btn'}
                 label={'Save'}
                 handleClick={handleSkillSubmission}
                 customStyle={{ border: '1px solid lightgrey' }}
             />
         </div>
     </div>
 </div>
 </div>
 
    }
    </>
    
 
  )
}

export default ProfessionalSkills